module.exports = __webpack_public_path__ + "static/media/SingleBlue.d4c4e70f.svg";